import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import * as AppActions from '../../actions';
import {
  getUsers,
  changeUserStatus,
  getGroups
} from '../../services/UserManagementService';
import UserList from './UserList';
import ManageUser from './ManageUser';
import './UserSearch.css';

class UserSearch extends Component {
  state = {
    token: this.props.getFbToken(),
    groups: [],
    users: null,
    section: 'search'
  };

  componentDidMount() {
    this.props.setSectionTitle('User Management');
    this.props.saveGTMEvent('User Management', 'Alexia');
    this.getUsers();
    this.getGroups();
  }

  getUsers = async () => {
    const userData = {
      requester: this.props.user.email.trim()
    };

    const users = await getUsers(userData);
    this.setState({
      users: _.orderBy(
        users.users.Users,
        [(user) => user.Username.toLowerCase()],
        ['asc']
      )
    });
  };

  getGroups = async () => {
    const userData = {
      requester: this.props.user.email.trim()
    };

    const groups = await getGroups(userData);
    this.setState({ groups: groups.groups.Groups });
  };

  newUser = () => {
    this.setState({ section: 'newUser', userToEdit: '' });
  };

  searchPage = () => {
    this.setState({ section: 'search' });
    this.getUsers();
  };

  changeUserStatus = async (username, enabled) => {
    const userData = {
      requester: this.props.user.email.trim(),
      username,
      enabled: !enabled
    };

    // eslint-disable-next-line no-unused-vars
    const result = await changeUserStatus(userData);
    this.getUsers();
  };

  editUser = (username) => {
    const user = this.state.users.find((item) => item.Username === username);
    this.setState({ section: 'newUser', userToEdit: user });
  };

  render() {
    const { users } = this.state;

    if (users) {
      return (
        <div className="container">
          {this.state.section === 'search' ? (
            <UserList
              users={this.state.users}
              newUser={this.newUser}
              searchPage={this.searchPage}
              changeUserStatus={this.changeUserStatus}
              editUser={this.editUser}
            />
          ) : null}
          {this.state.section === 'newUser' ? (
            <ManageUser
              searchPage={this.searchPage}
              groups={this.state.groups}
              userToEdit={this.state.userToEdit}
            />
          ) : null}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UserSearch);



// WEBPACK FOOTER //
// ./src/screens/User/UserSearch.js